module.exports = __webpack_public_path__ + "img/banner1_m.596158c7.jpg";